module.exports = __webpack_public_path__ + "static/img/8.33e924b3.png";